import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useLocale } from "@/context/LocaleContext";

export default function Cancel() {
  const { t } = useLocale();

  const canonicalUrl =
    typeof window !== "undefined"
      ? window.location.origin + "/cancel"
      : undefined;

  return (
    <>
      <Helmet>
        <title>Payment Cancelled - BuildStore</title>
        <meta
          name="description"
          content="Your payment was cancelled. You can retry anytime to purchase your e-commerce solution."
        />
        {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
        {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
        <meta property="og:title" content="Payment Cancelled - BuildStore" />
        <meta
          property="og:description"
          content="Your payment was cancelled. You can retry anytime to purchase your e-commerce solution."
        />
        <meta
          property="og:image"
          content="https://www.buildstore.it/logo-buildstore-v4.png"
        />
        <meta property="og:type" content="website" />
      </Helmet>
      <main className="container mx-auto pt-56 pb-20 text-center">
        <h1 className="text-3xl font-bold text-white">{t("cancel.title")}</h1>
        <p className="mt-2 text-white/70">{t("cancel.desc")}</p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-lg border border-white/20 px-6 py-2 text-white hover:bg-white/10"
        >
          {t("cancel.back_to_shop")}
        </Link>
      </main>
    </>
  );
}
